import React from 'react';
import { Phone, MessageCircle, Mail, Calendar } from 'lucide-react';

const VIUBUX_ISO = 'https://customer-assets.emergentagent.com/job_libro-quote-gen/artifacts/pf9umyn8_5.png';

export function FooterSection() {
  return (
    <footer className="border-t border-white/10 bg-[#0f133a]/80 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Contact */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4 flex items-center justify-center md:justify-start gap-2">
              <Phone className="w-4 h-4 text-[#aa2aff]" />
              Contacto
            </h4>
            <div className="space-y-2">
              <a 
                href="https://wa.me/525548564696" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center md:justify-start gap-2 text-slate-400 hover:text-[#25D366] transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
                <span>+52 55 4856 4696</span>
              </a>
              <a 
                href="mailto:email@viubux.com"
                className="flex items-center justify-center md:justify-start gap-2 text-slate-400 hover:text-[#aa2aff] transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>email@viubux.com</span>
              </a>
            </div>
          </div>

          {/* Schedule Meeting */}
          <div className="text-center">
            <h4 className="text-white font-semibold mb-4 flex items-center justify-center gap-2">
              <Calendar className="w-4 h-4 text-[#aa2aff]" />
              Agenda una Reunión
            </h4>
            <a 
              href="https://vbx.viubux.com/agenda" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#aa2aff] to-[#7012b2] text-white rounded-lg hover:opacity-90 transition-opacity"
            >
              <Calendar className="w-4 h-4" />
              Agenda Virtual
            </a>
          </div>

          {/* VCard */}
          <div className="text-center md:text-right">
            <h4 className="text-white font-semibold mb-4">Guarda nuestro contacto</h4>
            <a 
              href="https://vbx.viubux.com/vcard" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 border border-[#aa2aff] text-[#aa2aff] rounded-lg hover:bg-[#aa2aff]/10 transition-colors"
            >
              <Phone className="w-4 h-4" />
              Descargar VCard
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <img src={VIUBUX_ISO} alt="Viubux" className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm text-slate-500 mb-3">
            © {new Date().getFullYear()} Viubux. Todos los derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-xs">
            <a href="/politica-privacidad" className="text-slate-500 hover:text-[#aa2aff] transition-colors">
              Política de Privacidad
            </a>
            <span className="text-slate-600">•</span>
            <a href="/terminos-condiciones" className="text-slate-500 hover:text-[#aa2aff] transition-colors">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
